<div class="modal-header">
  <h5 class="modal-title">{{ title }}</h5>
  <button type="button" class="close" aria-label="Chiudi" (click)="activeModal.close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div *ngIf="!entries || entries.length === 0" class="text-muted">Nessuna operazione disponibile.</div>

  <div *ngIf="entries?.length" class="table-responsive">
    <table class="table table-sm table-striped mb-0">
      <colgroup>
        <col style="width:20%"> 
        <col style="width:10%"> 
        <col style="width:15%">
        <col style="width:55%">    
      </colgroup>
      <thead>
        <tr>
          <th>Data</th>
          <th>ID utente</th>
          <th>Ente</th>
          <th>Motivazione</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let e of entries">
          <td class="align-middle">
            {{ (e.data | date:'dd/MM/yyyy HH:mm:ss') || '-' }}
          </td>
          <td class="align-middle">
            {{ e.utente || '-' }}
          </td>
          <td class="align-middle">
            {{ e.ente || '-' }}
          </td>
          <td class="align-middle">
            {{ e.motivazione || '-' }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-primary" (click)="activeModal.close()">Chiudi</button>
</div>